'use client';

import { useEffect } from 'react';
import { useDiscountStore } from '@/store/discountStore';

export function useDiscount() {
  const discountPercent = useDiscountStore((state) => state.discountPercent);
  const isLoading = useDiscountStore((state) => state.isLoading);
  const lastUpdated = useDiscountStore((state) => state.lastUpdated);
  const updatedBy = useDiscountStore((state) => state.updatedBy);
  const setDiscountPercent = useDiscountStore((state) => state.setDiscountPercent);
  const fetchDiscount = useDiscountStore((state) => state.fetchDiscount);
  const calculateDiscountedPrice = useDiscountStore((state) => state.calculateDiscountedPrice);

  useEffect(() => {
    // Sync discount from server on mount
    fetchDiscount();
  }, [fetchDiscount]);

  return {
    discountPercent,
    isLoading,
    lastUpdated,
    updatedBy,
    setDiscountPercent,
    fetchDiscount,
    calculateDiscountedPrice,
  };
}
